import { render, staticRenderFns } from "./MultipleNumbersExternalProvider.vue?vue&type=template&id=24a87572"
import script from "./MultipleNumbersExternalProvider.vue?vue&type=script&lang=js"
export * from "./MultipleNumbersExternalProvider.vue?vue&type=script&lang=js"
import style0 from "./MultipleNumbersExternalProvider.vue?vue&type=style&index=0&id=24a87572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports